import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { Toaster } from "@/components/ui/sonner";
import { CountryDataProvider } from "@/contexts/CountryDataContext";
import { preloadWorldData } from "@/lib/map-data";
import App from "./App.js";

// Preload world map data on app startup so it's ready when user opens map modal
preloadWorldData();

// Register service worker for offline support
if ('serviceWorker' in navigator && import.meta.env.PROD) {
  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/sw.js')
      .then((registration) => {
        console.log('SW registered:', registration.scope);

        // Check for updates periodically
        setInterval(() => {
          registration.update();
        }, 60 * 60 * 1000); // Every hour
      })
      .catch((err) => {
        console.warn('SW registration failed:', err);
      });
  });
}

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <CountryDataProvider>
      <App />
      <Toaster />
    </CountryDataProvider>
  </StrictMode>
);
